
<template>
    <div>
        <img class="imgPagina" alt="Vue logo" src="@/assets/rino.webp">
        <p>Hola este es un ejemplo de pagina en vuejs</p>
        <button>Hola mundo</button>
    </div>
</template>

<script setup>
    
</script>

<style>
    .imgPagina {
        max-height: 14rem;
    }
</style>